import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { Stack } from '@metarouter-private/mr-mui';
import { resolveUserDisplayName } from '@ion/api/audit-logs/query';
import TextCell from 'app/components/data-table/TextCell';

export default function AuditLogUserCell({ userName, userEmail, userId }) {
  if (isEmpty(userName)) return <TextCell text={resolveUserDisplayName({ userName, userEmail, userId })} />;

  return (
    <Stack>
      <TextCell text={userName} />
      {!isEmpty(userEmail) && <TextCell text={userEmail} variant="caption" color="text.secondary" />}
    </Stack>
  );
}

AuditLogUserCell.propTypes = {
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  userId: PropTypes.string,
};
